export enum MalouHoursType {
    BREAKFAST = 'BREAKFAST',
    DRIVE_THROUGH = 'DRIVE_THROUGH',
    DELIVERY = 'DELIVERY',
    DINNER = 'DINNER',
    KITCHEN = 'KITCHEN',
    LUNCH = 'LUNCH',
    ACCESS = 'ACCESS',
    BRUNCH = 'BRUNCH',
    HAPPY_HOUR = 'HAPPY_HOUR',
    ONLINE_SERVICE_HOURS = 'ONLINE_SERVICE_HOURS',
    PICKUP = 'PICKUP',
    SENIOR_HOURS = 'SENIOR_HOURS',
    TAKEOUT = 'TAKEOUT',
}
